import * as React from "react";
import {IAddress} from "../../type/address";

export const Address: React.SFC<IAddress> = (props) => {
  return (
    <>
      {props.number} {props.street}, {props.zip} {props.city}
    </>
  )
};



// WEBPACK FOOTER //
// ./src/shared/Address/Address.tsx